import React, { Component } from 'react';
import PropTypes from "prop-types";
import { PhotoSlider } from 'react-photo-view';
import {get} from 'lodash'
import 'react-photo-view/dist/index.css'

class ImgPreView extends Component {
    static propTypes = {
        imgList: PropTypes.array.isRequired,            //[{src:"https://static.njtuling.com/staticfile/image/2019/2/90aadb90fabc4f938011ea07c967b5bb73.jpg", intro:'图片简介'}]
        previewVisible: PropTypes.bool,
        previewIndex: PropTypes.number,
        onClose: PropTypes.func.isRequired,
    }


    constructor(props) {
        super(props);
        console.log(this)
        this.state = {
            previewVisible: true,
            previewIndex: 0,
            imgList: [],
        }
    }
    static getDerivedStateFromProps(props, state) {
        return {
            imgList: get(props, 'imgList', []),
            previewVisible: get(props, 'previewVisible', false),
            previewIndex: get(props, 'previewIndex'),
            onClose: get(props, 'onClose'),
            setIndex: get(props, 'setIndex') || function () { console.log("缺少回调") },
        }
    }
    setPhotoIndex = (index) => {
        let { setIndex } = this.state
        setIndex(index)
        this.setState({
            previewIndex: index
        })
    }
    // 取消预览
    handleCancel = () => {
        this.state.onClose()
    }

    render() {
        return (
            <div>
                {
                    typeof window !== 'undefined' &&
                    <PhotoSlider
                        images={this.state.imgList.map(item => ({ src: item.src, intro: item.intro }))}
                        visible={this.state.previewVisible}
                        onClose={() => this.handleCancel()}
                        index={this.state.previewIndex}
                        setIndex={this.setPreviewIndex}
                        onIndexChange={this.setPhotoIndex}
                        toolbarRender={({ rotate, onRotate, onScale, scale, index }) => {
                            return (
                                <svg
                                    className="PhotoView-PhotoSlider__toolbarIcon"
                                    onClick={() => onRotate(rotate + 90)}
                                    width="44"
                                    height="44"
                                    fill="white"
                                    viewBox="0 0 768 768"
                                >
                                    <path d="M565.5 202.5l75-75v225h-225l103.5-103.5c-34.5-34.5-82.5-57-135-57-106.5 0-192 85.5-192 192s85.5 192 192 192c84 0 156-52.5 181.5-127.5h66c-28.5 111-127.5 192-247.5 192-141 0-255-115.5-255-256.5s114-256.5 255-256.5c70.5 0 135 28.5 181.5 75z" />
                                </svg>
                            );
                        }}
                    />
                }
            </div>
        );
    }
}
export default ImgPreView



// WEBPACK FOOTER //
// ./src/compenents/imgPreView.js